const SELECTOR = '.k-resource-entry .k-grid-content.k-auto-scrollable';

export const state = {
    syncSource: null,
    suppressScrollSync: 0,
};

export const syncAllGridScrolls = () => {
    $(SELECTOR).off('scroll.syncGrids').on('scroll.syncGrids', function() {
        if (state.suppressScrollSync > 0) return;
        if (state.syncSource && state.syncSource !== this) return;

        state.syncSource = this;
        const left = this.scrollLeft;

        $(SELECTOR).not(this).each(function() {
            this.scrollLeft = left;
        });

        requestAnimationFrame(() => { state.syncSource = null; });
    });
};

export const applyScrollPositionOnRefresh = (resource) => {
    let savedLeft = 0;
    $(SELECTOR).each(function() {
        savedLeft = Math.max(savedLeft, this.scrollLeft);
    });

    state.suppressScrollSync++;

    resource.grid.one('dataBound', function() {
        state.suppressScrollSync--;
        if (savedLeft > 0) {
            $(SELECTOR).each(function() { this.scrollLeft = savedLeft; });
        }
        syncAllGridScrolls();
    });

    resource._loadGrid();
};
